const notebook = {
    en: {
        notebook: {
            pageTitle: 'Notebook',
            pageDescription: 'Your personal learning journal. Create notes from translations and build your vocabulary with rich formatting.',
            notesLabel: 'Notes',
            emptyTitle: 'No notes yet',
            emptyDesc: 'Create a note from the translation page using the floating button.',
            noSearchMatch: 'No notes match your search',
            untitled: 'Untitled Note',
            cardLabel: 'Notebook',
            details: 'Details',
            deleteFailed: 'Failed to delete note. Please try again.',
            deleteNoteTitle: 'Delete Note',
            confirmDeleteTitle: 'Delete Note',
            confirmDeleteMessage: 'Are you sure you want to delete this note? This action cannot be undone.',
            tableAria: 'Notebook table',
            col: {
                title: 'Note Title',
                preview: 'Content Preview',
                date: 'Last Updated',
                actions: 'Actions',
            },
            saving: 'Saving...',
            saved: 'Saved',
            saveNow: 'Save Now',
            titlePlaceholder: 'Note title...',
            original: 'Original:',
            textColor: 'Text color: {color}',
            tool: {
                bold: 'Bold',
                italic: 'Italic',
                underline: 'Underline',
                highlight: 'Highlight',
                heading: 'Heading',
            },
            selectTitle: 'Save Note to...',
            searchPlaceholder: 'Search existing notes...',
            createNew: 'Create New Note',
            createNewDesc: 'Start a fresh notebook entry',
            loading: 'Loading your notes...',
            noNotesFound: 'No existing notes found.',
            recentNotes: 'Recent Notes',
            translationFallback: 'Translation',
        },
    },
    th: {
        notebook: {
            pageTitle: 'สมุดโน้ต',
            pageDescription: 'สมุดบันทึกการเรียนรู้ส่วนตัวของคุณ สร้างโน้ตจากการแปลและสร้างคลังคำศัพท์ด้วยการจัดรูปแบบที่หลากหลาย',
            notesLabel: 'โน้ต',
            emptyTitle: 'ยังไม่มีโน้ต',
            emptyDesc: 'สร้างโน้ตจากหน้าการแปลด้วยปุ่มลอย',
            noSearchMatch: 'ไม่มีโน้ตที่ตรงกับการค้นหา',
            untitled: 'โน้ตไม่มีชื่อ',
            cardLabel: 'สมุดโน้ต',
            details: 'รายละเอียด',
            deleteFailed: 'ลบโน้ตไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
            deleteNoteTitle: 'ลบโน้ต',
            confirmDeleteTitle: 'ลบโน้ต',
            confirmDeleteMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบโน้ตนี้? การกระทำนี้ไม่สามารถย้อนกลับได้',
            tableAria: 'ตารางสมุดโน้ต',
            col: {
                title: 'ชื่อโน้ต',
                preview: 'ตัวอย่างเนื้อหา',
                date: 'อัปเดตล่าสุด',
                actions: 'จัดการ',
            },
            saving: 'กำลังบันทึก...',
            saved: 'บันทึกแล้ว',
            saveNow: 'บันทึกทันที',
            titlePlaceholder: 'ชื่อโน้ต...',
            original: 'ต้นฉบับ:',
            textColor: 'สีข้อความ: {color}',
            tool: {
                bold: 'ตัวหนา',
                italic: 'ตัวเอียง',
                underline: 'ขีดเส้นใต้',
                highlight: 'ไฮไลต์',
                heading: 'หัวข้อ',
            },
            selectTitle: 'บันทึกโน้ตไปยัง...',
            searchPlaceholder: 'ค้นหาโน้ตที่มีอยู่...',
            createNew: 'สร้างโน้ตใหม่',
            createNewDesc: 'เริ่มบันทึกโน้ตใหม่',
            loading: 'กำลังโหลดโน้ตของคุณ...',
            noNotesFound: 'ไม่พบโน้ตที่มีอยู่',
            recentNotes: 'โน้ตล่าสุด',
            translationFallback: 'การแปล',
        },
    },
};

export default notebook;
